import React from 'react'
import ReactDOM from 'react-dom'
import {
  DataTable,
  Card,
  Page,
  DescriptionList,
  FooterHelp,
  Checkbox,
  Layout,
  Link,
  TextField,
  Thumbnail
} from '@shopify/polaris'
import PrintSummaryTable from './print_summary_table'
import ShippingLines from './shipping_lines'
import OrderNotes from './order_notes'
export default class OrderSummary extends React.Component {

  constructor(props) {
    super(props)
    let barcodes = false
    let shippingLines = false
    let images = false
    let filter = ""
    let opts = { barcodes: barcodes, images: images, shippingLines: shippingLines, filter: filter }
    this.state = {
      barcodes: barcodes,
      shippingLines: shippingLines,
      images: images,
      excludeFulfilled: false,
      filter: "",
      columns: this.buildColumns(opts),
      headings: this.buildHeadings(opts),
      sortable: this.buildSortable(opts),
      rawSortedRows: this.props.summary_line_items,
      sortedRows: [],
      jwt: this.props.jwt,
      orderIds: this.props.order_ids,
      sortKey: "title",
      sortDirection: "ascending"
    }
  }

  defaultBuildOpts() {
    return { barcodes: this.state.barcodes, images: this.state.images, shippingLines: this.state.shippingLines, filter: this.state.filter }
  }

  summaryLineItems() {
    return this.state.excludeFulfilled ? this.props.unfulfilled_summary_line_items : this.props.summary_line_items
  }

  filterVariants(filterString) {
    let opts = { ...this.defaultBuildOpts(), ...{ filter: filterString } }
    this.setState({
      filter: filterString,
      sortedRows: this.buildRows(this.summaryLineItems(), opts)
    })
  }

  buildColumns(opts) {
    let base = [
      'text',
      'text',
      'numeric',
      'text',
      'numeric'
    ]
    if (opts.barcodes) base.push("text")
    if (opts.images) base.unshift("text")
    return base
  }

  buildHeadings(opts) {
    let base = [
      'Product',
      'Variant',
      'Quantity',
      'SKU Number',
      'Contained in Orders'
    ]
    if (opts.barcodes) base.push('Barcode')
    if (opts.images) base.unshift('Image')
    return base
  }

  buildSortable(opts) {
    let base = [true, true, false, false, false]
    if (opts.barcodes) base.push(true)
    if (opts.images) base.unshift(false)
    return base
  }

  buildRows(slis, opts) {
    let rows = []
    let oam = this.props.order_address_map
    let filter = opts.filter
    for (let i = 0; i < slis.length; i++) {
      let sli = slis[i]
      let filterString = sli.title + sli.variant_title + sli.sku;
      if (!filterString.includes(filter)) {
        continue;
      }
      let image = ""
      if (sli.image) {
        image = <Thumbnail source={sli.image} alt={sli.title} size="small"></Thumbnail>
      }
      let base = [sli.title, sli.variant_title, sli.quantity, sli.sku, sli.order_count]
      if (opts.barcodes) { base.push(sli.barcode) }
      if (opts.images) { base.unshift(image) }
      rows.push(base)
      // if there is an address associated with line item's order, add it to summary
      if (opts.shippingLines) {
        let containsShipping =
          sli.order_ids
            .find(order_id => {
              return oam[order_id]
            })

        if (containsShipping) {
          rows.push([<ShippingLines summary_line_item={sli} order_address_map={oam} order_notes={this.props.order_notes}></ShippingLines>])
        }
      }
    }
    return rows
  }

  sort(_rows, index, direction) {
    let keys = ["title", "variant_title", "quantity", "sku", "order_count"]
    if (this.state.barcodes) keys.push("barcode")
    if (this.state.images) keys.unshift("image")
    let sortKey = keys[index]

    // Sort the summary line items
    let slis =
      this.summaryLineItems()
        .sort((sliA, sliB) => {
          let a = sliA[sortKey] ? sliA[sortKey] : ''
          let b = sliB[sortKey] ? sliB[sortKey] : ''
          if (direction === 'descending') return b.localeCompare(a)
          else return a.localeCompare(b)
        })

    this.setState({
      rawSortedRows: slis,
      sortKey: sortKey,
      sortDirection: direction
    })

    // then build the sorted rows from the sorted summary line items
    return this.buildRows(slis, this.defaultBuildOpts())
  }

  print() {
    let table = document.getElementById('print-table').cloneNode(true)
    var frame = document.createElement('IFRAME')
    frame.domain = document.domain
    frame.style.position = "absolute"
    // frame.style.top = "-10000px"
    document.body.appendChild(frame)
    frame.contentDocument.body.appendChild(table)
    frame.focus()
    frame.contentWindow.print()
    frame.parentNode.removeChild(frame)
    window.focus()
  }

  toggleImages(boxValue) {
    let opts = { ...this.defaultBuildOpts(), ...{ images: boxValue } }
    this.setState({
      images: boxValue,
      columns: this.buildColumns(opts),
      headings: this.buildHeadings(opts),
      sortable: this.buildSortable(opts),
      rawSortedRows: this.summaryLineItems(),
      sortedRows: this.buildRows(this.summaryLineItems(), opts)
    })
  }

  toggleBarcodes(boxValue) {
    let opts = { ...this.defaultBuildOpts(), ...{ barcodes: boxValue } }
    this.setState({
      barcodes: boxValue,
      columns: this.buildColumns(opts),
      headings: this.buildHeadings(opts),
      sortable: this.buildSortable(opts),
      rawSortedRows: this.summaryLineItems(),
      sortedRows: this.buildRows(this.summaryLineItems(), opts)
    })
  }

  toggleShippingLines(boxValue) {
    let opts = { ...this.defaultBuildOpts(), ...{ shippingLines: boxValue } }
    this.setState({
      shippingLines: boxValue,
      sortedRows: this.buildRows(this.summaryLineItems(), opts)
    })
  }

  toggleExcludeFulfilled(boxValue) {
    let slis = boxValue ? this.props.unfulfilled_summary_line_items : this.props.summary_line_items
    this.setState({
      excludeFulfilled: boxValue,
      rawSortedRows: slis,
      sortedRows: this.buildRows(slis, this.defaultBuildOpts())
    })
  }

  flushTableRows() {
    let shippingLines = ReactDOM.findDOMNode(this).getElementsByClassName("Polaris-DataTable__Cell")
    for (let i = 0; i < shippingLines.length; i++) {
      shippingLines[i].setAttribute("colspan", "1")
      shippingLines[i].classList.remove("shipping-lines-parent")
    }
  }

  fixTableRows() {
    let shippingLines = ReactDOM.findDOMNode(this).getElementsByClassName("shipping-lines")
    for (let i = 0; i < shippingLines.length; i++) {
      shippingLines[i].parentNode.classList.add("shipping-lines-parent")
      shippingLines[i].parentNode.setAttribute("colspan", "10")
    }
  }

  componentDidMount() {
    this.setState({
      sortedRows: this.sort([], 0, 'ascending')
    })

    this.fixTableRows()
  }

  componentDidUpdate() {
    this.flushTableRows()
    this.fixTableRows()
  }

  render() {
    const handleSort = (index, direction) => {
      this.setState({ sortedRows: this.sort(this.buildRows(this.state, this.defaultBuildOpts()), index, direction) })
    }
    return <Page
      fullWidth
      title="Order summary"
      primaryAction={{
        content: 'Print',
        onAction: () => {
          this.print()
          this.forceUpdate()
        }
      }}
      secondaryActions={[{
        content: 'Print button not working? Click here to open summary in new tab', onAction: () => {
          window.open(`/summary?sort_key=${this.state.sortKey}&sort_direction=${this.state.sortDirection}&order_ids=${this.state.orderIds}&show_images=${this.state.images}&show_barcodes=${this.state.barcodes}&show_shipping_lines=${this.state.shippingLines}&exclude_fulfilled=${this.state.excludeFulfilled}&token=${this.state.jwt}`, '_blank').focus();
        }
      }]}>
      <Layout>
        <Layout.Section oneThird>
          <TextField
            label="Filter variants"
            placeholder="Case sensitive. Remove variants which match filter"
            value={this.state.filter}
            onChange={
              (filterString) => {
                this.filterVariants(filterString)
              }
            }
          />
        </Layout.Section>
      </Layout>
      <Layout>
        <Layout.Section oneThird>
          <Checkbox
            label="Include images"
            checked={this.state.images}
            onChange={
              (boxValue) => {
                this.toggleImages(boxValue)
              }
            }
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <Checkbox
            label="Include barcodes"
            checked={this.state.barcodes}
            onChange={
              (boxValue) => {
                this.toggleBarcodes(boxValue)
              }
            }
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <Checkbox
            label="Include shipping lines"
            checked={this.state.shippingLines}
            onChange={
              (boxValue) => {
                this.toggleShippingLines(boxValue)
              }
            }
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <Checkbox
            label="Exclude fulfilled line items"
            checked={this.state.excludeFulfilled}
            onChange={
              (boxValue) => {
                this.toggleExcludeFulfilled(boxValue)
              }
            }
          />
        </Layout.Section>
      </Layout>
      <Card>
        <div id="piknpak-table">
          <DataTable
            columnContentTypes={this.state.columns}
            headings={this.state.headings}
            rows={this.state.sortedRows}
            sortable={this.state.sortable}
            initialSortColumnIndex={0}
            onSort={handleSort}
          />
        </div>
      </Card>
      {this.state.shippingLines &&
        <>
          <p><strong>Order notes</strong></p>
          <OrderNotes order_notes={this.props.order_notes}></OrderNotes>
        </>
      }
      <DescriptionList
        items={[
          {
            term: 'Contained in Orders',
            description:
              'The total number of orders in which this product variant is contained.',
          }
        ]}
      />
      <PrintSummaryTable rows={this.state.rawSortedRows} showImages={this.state.images} showBarcodes={this.state.barcodes} showShippingLines={this.state.shippingLines} order_address_map={this.props.order_address_map} order_notes={this.props.order_notes} filter={this.state.filter} />

      {/* <FooterHelp>
        Love PiknPak? Consider making a contribution to help it's development and keep it free.
        <p style={{ textAlign: "center" }}>
          <Link url={"/donate-10?token=" + this.props.jwt}>$10</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link url={"/donate-25?token=" + this.props.jwt}>$25</Link>&nbsp;&nbsp;&nbsp;&nbsp;
          <Link url={"/donate-50?token=" + this.props.jwt}>$50</Link>
        </p>
      </FooterHelp> */}
    </Page >
  }
}